import { NextPageParams, type NotificationsResponse } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchNotifications(context: ApiContext, nextPageParams?: NextPageParams) {
  const params = new URLSearchParams()

  if (nextPageParams) {
    params.append("page", String(nextPageParams.page))
    params.append("per_page", String(nextPageParams.per_page))
  }

  const queryString = params.toString()
  const url = `notifications${queryString ? `?${queryString}` : ""}`

  return apiContextFetch<NotificationsResponse>(context, url)
}

export function fetchUnreadNotificationCount(context: ApiContext) {
  return apiContextFetch<{ unread_count: number }>(context, `notifications/unread_count`)
}

export function markNotificationAsRead(context: ApiContext, id: string) {
  return apiContextFetch<{ success: boolean; unread_count: number }>(context, `notifications/${id}/mark_as_read`, {
    method: "PUT",
  })
}

export function markNotificationAsUnread(context: ApiContext, id: string) {
  return apiContextFetch<{ success: boolean; unread_count: number }>(context, `notifications/${id}/mark_as_unread`, {
    method: "PUT",
  })
}

export function markAllNotificationsAsRead(context: ApiContext) {
  return apiContextFetch<{ success: boolean; unread_count: number }>(context, `notifications/mark_all_as_read`, {
    method: "PUT",
  })
}
